export default __webpack_public_path__ + "navigation-guides-free-drive-ui-960-c06db9320b648136404a613c9ac0556e.webp";